module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zrMJMw/media/FC-9781528963114.jpg?1685327250855",
      "alt": "This image is the cover for the book Third Calling: Triton's Reign - Light of a New Day Book 3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Third Calling: Triton's Reign - Light of a New Day Book 3\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Hamilton Key returns to Erotica, the lost city destroyed by exiles and alien warfare, zombie apocalypse, destruction and corruption of government. The world seizes as he attempts to return to the city in order to attract survivors to his new colony in the Bahamas, that remains just miles from an underwater alien experiment of oil and minerals. This leads him to try and uncover the deadly secret that eats at society and eats away at his soul.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Damian Forest Light\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Damian Forest Light is a writer, composer, and performer from New York City. He was honoured as ‘Poet of the Year 2006’ by International Library of Congress. He has an M.A. and studies as a writer and moonlighter, hiking and working throughout the deserts of North America.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0